import { useEffect } from 'react'
import { useLocation } from 'wouter'
import { useSessionStore } from '@/store/sessionStore'
import { useAuthStore } from '@/store/authStore'

interface UseSessionEndOnNavigateOptions {
  enabled: boolean
  studyRoutes: string[]
}

function isStudyRoute(location: string, routes: string[]): boolean {
  return routes.some(route => {
    if (route.endsWith('*')) {
      return location.startsWith(route.slice(0, -1))
    }
    if (route.endsWith('/')) {
      return location.startsWith(route)
    }
    return location === route
  })
}

export function useSessionEndOnNavigate({ enabled, studyRoutes }: UseSessionEndOnNavigateOptions) {
  const [location] = useLocation()
  const user = useAuthStore((state) => state.user)
  const endSession = useSessionStore((state) => state.endSession)
  const isRunning = useSessionStore((state) => state.isRunning)
  const sessionId = useSessionStore((state) => state.sessionId)

  useEffect(() => {
    if (!enabled || !user?.id || !isRunning || !sessionId) return

    if (!isStudyRoute(location, studyRoutes)) {
      endSession().catch(console.error)
    }
  }, [enabled, user?.id, isRunning, sessionId, location, studyRoutes, endSession])
}
